<template>
  <InfoList
    :title="$t('pages.onboarding.admin_page.reviewed_documents')"
    button-label="">
    <div
      class="onboarding-user-docs-wrapper">
      <template
        v-for="doc in documents"
        :key="doc">
        <DocumentRow
          :is-reviewed-doc="true"
          :document-file="doc"
          :hide-upload="true"
          :is-external-loading="loadingKeys.has(getDocKey(doc))"
          @download="onDownload"/>
      </template>
    </div>
  </InfoList>
</template>

<script setup lang="ts">

import { ref } from 'vue';
import { useRoute } from 'vue-router';

import InfoList from '@/components/InfoList.vue';
import DocumentRow from '@/modules/onboarding-user-profile/components/document-row.vue';
import {
  ReviewedDocument,
} from '@/types/interfaces/Document.interface';

const {
  documents,
  downloadFile,
} = defineProps<{
  documents: ReviewedDocument[];
  downloadFile: Function;
}>();

const { params: { id } } = useRoute();

const loadingKeys = ref(new Set<string>());
function getDocKey(doc: ReviewedDocument) {
  return `${doc.type}_${doc.side}`;
}

async function onDownload(currentDocument: ReviewedDocument) {
  const key = getDocKey(currentDocument);
  loadingKeys.value.add(key);

  const { type, fileDocument } = currentDocument;
  const response = await downloadFile(id, fileDocument.imageId);

  loadingKeys.value.delete(key);

  if (!response) return;

  const data = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = data;
  link.download = `${type}.${fileDocument.extension}`;
  link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

  setTimeout(() => {
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
}
</script>

<style lang="scss">
.onboarding-user-docs {
  &-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    .formkit-wrapper {
      @apply w-[145px];
    }
  }

  &-item {
    display: flex;
    width: 100%;
    padding: 4px 8px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    &:hover {
      @apply bg-old-n-blue-20;

      & .onboarding-user-docs-item__btns {
        display: flex;
      }
    }

    &__title {
      color: #10233a;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px;
      display: flex;
      align-items: center;
      gap: 4px;
    }

    &__btns {
      gap: 12px;
      display: none;
      color: #7288a3;
      height: 18px;
      align-items: center;

      i::before {
        @apply text-lg;
      }
    }
  }
}
</style>
